const base = require('./base');
const detail = require('./detail');
const isBreakpointMobile = require('../common/utils/isMatchedBreakpoint');
const { STATE_ADD_TO_BAG } = require('../interactions/add-to-bag');
const { STATE_ADD_TO_BAG_MOBILE } = require('../interactions/add-to-bag-mobile');
const { getVariationAttributeFromProduct } = require('../common/helpers/productModelHelpers');

function getChildrenHeight(parent) {
  const children = $(parent).children();
  let totalHeight = 0;
  for (let i = 0, len = children.length; i < len; i++) {
    const child = children[i];
    if ($(child).is(':visible')) totalHeight += $(child).outerHeight(true); // with margins
  }
  return totalHeight;
}

function pdpSetAccordionsHeight(baseAccordion) {
  const stickyContainer = $(baseAccordion).closest(
    '.the-product-details__sticky-container',
  );
  const accordionContent = $(baseAccordion).find('.base-accordion__content');

  accordionContent.height('');
  const accordionContentHeight = accordionContent.outerHeight();
  const childrenHeight = getChildrenHeight(stickyContainer);
  const stickyHeight = stickyContainer.height(); // without paddings

  if (
    !$(baseAccordion).hasClass('expanded')
        || isBreakpointMobile.matches()
        || childrenHeight <= stickyHeight
  ) return;

  let newHeight = accordionContentHeight - (childrenHeight - stickyHeight);
  newHeight = Math.min(Math.max(85, newHeight), accordionContentHeight);
  accordionContent.height(newHeight);
  stickyContainer[0].scrollTo(0, accordionContent.offset().top);
}

function getAddToCartButtons(data) {
  const selectorUuid = data && data.uuid ? `[data-uuid="${data.uuid}"]` : '';
  const desktopButtonSelector = `.interaction--add-to-bag${selectorUuid}`;
  const mobileButtonSelector = `.interaction--add-to-bag-mobile${selectorUuid}`;

  return [$(desktopButtonSelector), $(mobileButtonSelector)];
}

module.exports = {
  availability: base.availability,
  addToCart: base.addToCart,

  updateAttributesAndDetails: detail.updateAttributesAndDetails,
  /*
     * Disable default show spinner to prevent the spinner from appearing on
     * every addToCart action.
     * Done for quickShop, which will have its specific animation, but it's \
     * likely that we won't need it anywhere and we should to remove it
     * definitely.
     *
     * Original code:
     * ```
     *    showSpinner: function () {
     *        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', function () {
     *            $.spinner().start();
     *        });
     *    },
     * ```
     */
  // showSpinner: detail.showSpinner,

  updateAttribute: detail.updateAttribute, // Updates pid
  updateAddToCart: detail.updateAddToCart,
  updateAvailability: detail.updateAvailability,
  sizeChart: detail.sizeChart,
  copyProductLink: detail.copyProductLink,

  /* ByL custom method */
  updateStockAlertSection() {
    $('.show-alertstock-popup').on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      $('.product-stock-alert-signup').addClass('show');
    });

    $('.product-stock-alert-signup').on('click', () => {
      $('.product-stock-alert-signup').removeClass('show');
    });

    $('.product-stock-alert-signup .container').on('click', (e) => {
      e.stopPropagation();
    });
  },

  /* ByL custom method */
  subscribeAlertStockButton() {
    function displayMessage(data, button) {
      $.spinner().stop();
      button.removeAttr('disabled');
    }

    $('button.stockalert-subscribe-email').on('click', function stockAlertSubscribeEmailClick(e) {
      e.preventDefault();
      const url = $(this).data('href');
      const button = $(this);
      const email = $('input[name=psAlertSignUp_email]').val();
      const pid = $('button.add-to-cart').attr('data-pid');
      const sizeId = $('input[name=psAlertSignUp_size]:checked').val();
      $.spinner().start();
      $(this).attr('disabled', true);
      $.ajax({
        url,
        type: 'post',
        dataType: 'json',
        data: {
          email,
          pid,
          size_id: sizeId,
        },
        success(data) {
          displayMessage(data, button);
        },
        error(err) {
          displayMessage(err, button);
        },
      });
    });
  },

  focusChooseBonusProductModal: base.focusChooseBonusProductModal(),
  pdpInitAccordionsHeight() {
    $(document).on(
      'click',
      '.product-detail .base-accordion__title',
      function onAccordionTitleClick() {
        pdpSetAccordionsHeight($(this).closest('.base-accordion'));
      },
    );
  },
  initProductImagesZoom() {
    $('body').on('the-product-details:image-zoom', (event, data) => {
      const zoomContainer = $('.the-product-details-zoom');
      const htmlScroll = $('html').scrollTop();
      const page = $('.page');
      const zoomedImage = $(zoomContainer.find('picture img')[data.ordinal]);
      const newRelativeTop = zoomedImage.height() * data.percentileY;

      const scrollNumber = newRelativeTop + zoomedImage.offset().top;

      $(zoomContainer).scrollTop(scrollNumber - (window.innerHeight / 2) - htmlScroll);
      page.data('scroll', htmlScroll);
      page.addClass('zoom-open');
    });

    $('body').on('the-product-details:after-image-zoom-close', () => {
      const page = $('.page');
      $('.the-product-details-zoom').scrollTop(0);
      page.removeClass('zoom-open');
      $('html').scrollTop(page.data('scroll'));
      page.removeData('scroll');
    });
  },

  /**
   * Adds add to cart interaction handlers on add to cart process
   *
   */
  addToCartHandlers() {
    // ON BEFORE ADD TO CART
    $('body').on('product:beforeAddToCart', (evt, data) => {
      const [$desktopButton, $mobileButton] = getAddToCartButtons(data);

      // SET DESKTOP BUTTON TO BUSY STATE
      $('body').trigger('interaction--add-to-bag-event',
        { target: $desktopButton, state: STATE_ADD_TO_BAG.BUSY });
      // SET MOBILE BUTTON TO BUSY STATE
      $('body').trigger('interaction--add-to-bag-mobile-event',
        { target: $mobileButton, state: STATE_ADD_TO_BAG_MOBILE.BUSY });
    });

    // ON AFTER ADD TO CART
    $('body').on('product:afterAddToCart', (evt, data) => {
      const [$desktopButton, $mobileButton] = getAddToCartButtons(data);

      // SET DESKTOP BUTTON TO ADDED STATE
      $('body').trigger('interaction--add-to-bag-event',
        { target: $desktopButton, state: STATE_ADD_TO_BAG.ADDED });
      // SET MOBILE BUTTON TO ADDED STATE
      $('body').trigger('interaction--add-to-bag-mobile-event',
        { target: $mobileButton, state: STATE_ADD_TO_BAG_MOBILE.ADDED });
      $mobileButton.data('interactionAddToCart', false);

      const sizes = getVariationAttributeFromProduct(data.product, 'size')?.values;
      const isUniqueSize = sizes?.length === 1 && sizes[0].selectable;

      if (isUniqueSize || !data.product) {
        setTimeout(() => {
          $('body').trigger('interaction--add-to-bag-event',
            { target: $desktopButton, state: STATE_ADD_TO_BAG.ENABLED });
        }, 2000);
      } else {
        setTimeout(() => {
          $('body').trigger('interaction--add-to-bag-event',
            { target: $desktopButton, state: STATE_ADD_TO_BAG.DISABLED });
        }, 2000);
      }
    });

    // ON AFTER ADD TO CART ERROR
    // TODO REVISAR ESTADO ERROR
    $('body').on('product:afterAddToCartError', () => {
      const $desktopButton = $('.interaction--add-to-bag');
      const $mobileButton = $('.interaction--add-to-bag-mobile');
      // SET DESKTOP BUTTON TO STATE ENABLED
      $('body').trigger('interaction--add-to-bag-event',
        { target: $desktopButton, state: STATE_ADD_TO_BAG.ENABLED });
      // SET MOBILE BUTTON TO STATE ENABLED
      $mobileButton.data('interactionAddToCart', false);
    });

    // ON BEFORE ATTRIBUTE SELECT
    $('body').on('product:beforeAttributeSelect', (event, data) => {
      const notAddToCartRelated = data.container.hasClass('product-quickview');
      if (notAddToCartRelated) {
        return;
      }
      const $desktopButton = $('.interaction--add-to-bag');
      const $mobileButton = $('.interaction--add-to-bag-mobile');

      // SET DESKTOP BUTTON TO BUSY STATE
      $('body').trigger('interaction--add-to-bag-event',
        { target: $desktopButton, state: STATE_ADD_TO_BAG.BUSY });
      // SET MOBILE BUTTON TO BUSY STATE
      $('body').trigger('interaction--add-to-bag-mobile-event',
        { target: $mobileButton, state: STATE_ADD_TO_BAG_MOBILE.BUSY });
    });

    // ON AFTER ATTRIBUTE SELECT
    $('body').on('product:afterAttributeSelect', (event, data) => {
      const $desktopButton = $('.interaction--add-to-bag');
      const $mobileButton = $('.interaction--add-to-bag-mobile');

      const $sfraSizeSelector = $('.select-size', data.container);
      const notAddToCartRelated = data.container.hasClass('product-quickview');
      if ($sfraSizeSelector.length <= 0 || notAddToCartRelated) {
        return;
      }

      // NO SELECTED SIZE
      if ($sfraSizeSelector[0].selectedIndex === -1) {
        // DESKTOP BUTTON TO DISABLED STATE
        $('body').trigger('interaction--add-to-bag-event',
          { target: $desktopButton, state: STATE_ADD_TO_BAG.DISABLED });
      } else {
        // BUTTON TO ENABLED STATE
        $('body').trigger('interaction--add-to-bag-event',
          { target: $desktopButton, state: STATE_ADD_TO_BAG.ENABLED });
      }
      // MOBILE BUTTON TO ENABLED STATE
      if (!$mobileButton.data('interactionAddToCart')) {
        $('body').trigger('interaction--add-to-bag-mobile-event',
          { target: $mobileButton, state: STATE_ADD_TO_BAG_MOBILE.ENABLED });
      }

      // TODO revisar funcionamiento de error show
      const $addToCartError = $('.the-product-details__add-to-cart-error');
      $addToCartError
        .removeClass('the-product-details__add-to-cart-error--show');
    });
  },
};
